import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { resolveUrl } from '../lib/api';

export default function PageHeader({ title, breadcrumb, heroImage }) {
  const bg = heroImage ? resolveUrl(heroImage) : '';
  return (
    <section className="relative pt-32 pb-16 md:pt-40 md:pb-20 bg-[#0F1C2E] overflow-hidden">
      {bg && (
        <img src={bg} alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" />
      )}
      <div className="absolute inset-0 opacity-20" style={{ backgroundImage: 'radial-gradient(circle at 30% 30%, rgba(237,46,46,0.4) 0%, transparent 50%), radial-gradient(circle at 70% 70%, rgba(245,166,35,0.25) 0%, transparent 50%)' }} />
      <div className="absolute -right-20 -top-20 w-96 h-96 rounded-full bg-[#ED2E2E]/10 blur-3xl" />
      {bg && <div className="absolute inset-0 bg-gradient-to-t from-[#0F1C2E]/85 via-[#0F1C2E]/50 to-[#0F1C2E]/30" />}
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 text-center">
        <h1 className="section-title text-white text-4xl md:text-6xl mb-4">{title}</h1>
        <div className="flex items-center justify-center gap-2 text-white/70 text-sm">
          <Link to="/" className="hover:text-[#ED2E2E]">Home</Link>
          <ChevronRight size={14} />
          <span className="text-[#ED2E2E]">{breadcrumb}</span>
        </div>
      </div>
    </section>
  );
}
